<script setup lang="ts">
import './assets/style.scss'
import { VIcons } from '@/shared/ui'
import { useRoute } from 'vue-router'

const route = useRoute()

const createLink = (tab: string) => {
  const schedule_id = route.params.schedule_id as string

  return `/schedules/${schedule_id}/${tab}`
}
</script>

<template>
  <div class="w-schedules-menu">
    <router-link
      class="w-object-menu__link"
      :class="{ 'router-link-active': route.params.sked_tab == 'programs' }"
      :to="createLink('programs')"
    >
      <VIcons type="date_range" />
      <p>{{ $t('itf.programs') }}</p>
    </router-link>

    <router-link
      class="w-object-menu__link"
      :class="{ 'router-link-active': route.params.sked_tab == 'work-time' }"
      :to="createLink('work-time')"
    >
      <VIcons type="schedule" />
      <p>{{ $t('itf.work_time') }}</p>
    </router-link>
  </div>
</template>
